module.exports = __webpack_public_path__ + "static/media/gcp.6411dbc9.svg";